import { render } from "./OrgInstructorClassrooms.vue?vue&type=template&id=632067e4&scoped=true"
import script from "./OrgInstructorClassrooms.vue?vue&type=script&lang=js"
export * from "./OrgInstructorClassrooms.vue?vue&type=script&lang=js"

import "./OrgInstructorClassrooms.vue?vue&type=style&index=0&id=632067e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632067e4"]])

export default __exports__